import React from "react"

const IconShield = () => {
   return (
      <svg
         xmlns="http://www.w3.org/2000/svg"
         width="24"
         height="24"
         viewBox="0 0 24 24"
      >
         <path d="M12 0C9.004 2.995 4.514 4 1 4c0 8.583 5.067 16.097 11 20 5.932-3.903 11-11.417 11-20-3.515 0-8.006-1.005-11-4zm-.587 14.953l-3.452-3.362 1.237-1.239 2.215 2.123L15.794 8l1.238 1.238-5.619 5.715z"></path>
      </svg>
   )
}

export { IconShield as default }
